import { render, staticRenderFns } from "./AuctionsOptions.vue?vue&type=template&id=bba14774&"
import script from "./AuctionsOptions.vue?vue&type=script&lang=js&"
export * from "./AuctionsOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bba14774')) {
      api.createRecord('bba14774', component.options)
    } else {
      api.reload('bba14774', component.options)
    }
    module.hot.accept("./AuctionsOptions.vue?vue&type=template&id=bba14774&", function () {
      api.rerender('bba14774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/auctions/views/components/AuctionsOptions.vue"
export default component.exports